import { Media, MediaType } from '../../models/mediaClass';

const initialState =
  {
    fgImage: Media,
    fgVideo: Media,
    background: Media,
  };

  export const SELECT_BACKGROUND = 'SELECT_BACKGROUND';

  export const SELECT_MEDIA = 'SELECT_MEDIA';
  export const UNSELECT_MEDIA = 'UNSELECT_MEDIA';


export const MediaReducer = (state = initialState, action) => {
  switch (action.type) {

    case SELECT_BACKGROUND: {
      // console.log(state, action);
      return { ...state, background: action.payload };
    }

    case SELECT_MEDIA: {
      // payload contains a media
      if (action.payload.type === MediaType.FG_IMAGE) {
        return {...state, fgImage: action.payload};
      } else if (action.payload.type === MediaType.FG_VIDEO) {
        return {...state, fgVideo: action.payload};
      } else {
        return state;
      }
    }

    case UNSELECT_MEDIA: {
      // payload contains a type
      // console.log(state, action);
      if (action.payload === MediaType.FG_IMAGE) {
        return {...state, fgImage: null};
      } else if (action.payload === MediaType.FG_VIDEO) {
        return {...state, fgVideo: null};
      } else if (action.payload === MediaType.BG_IMAGE || action.payload === MediaType.BG_VIDEO) {
          return {...state, background: null};
        } else {
        return state;
      }
    }



    default:
      return state;
  }
};
